// JsFromRoutes CacheKey f6a69a3c5ec547e133f1bfe14f9f77a1
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from "@js-from-routes/client"

export default {
  create: /* #__PURE__ */ definePathHelper("post", "/api/images"),
  update: /* #__PURE__ */ definePathHelper("patch", "/api/images/:id"),
  destroy: /* #__PURE__ */ definePathHelper("delete", "/api/images/:id"),
}
